<script lang="ts">
  import { Splide, SplideSlide } from "@splidejs/svelte-splide";
  import InstallButton from "./InstallButton.svelte";
  import { VIDEO_FEED_BLOCK } from "@/constants/constants";
  import constants from "@/constants";
  import "@splidejs/svelte-splide/css";
  import Logo from "$assets/icons/xhdpi.png";
  import { POP_UP_HEADINGS } from "@/constants/constants";
  import ImageUrls from "@/constants/ImageUrls";

  export let isHardNudge = false;
  export let getInstallImage: () => { src: string; srcSet: string };
  export let trackDownloadClick: () => void;
  export let isFirstVideo = false;
  export let trackRemindClick: () => void;
  export let nudgeType: string;
  export let isShareSheet = false;
  export let onClose: () => void;

  const carouselOptions = {
    autoplay: true,
    rewind: true,
    updateOnMove: true,
    pagination: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    classes: {
      arrows: "hidden",
      arrow: "hidden",
      page: "splide-pagination-page bg-grey3 h-0.5 w-2 rounded-sm",
      pagination: "flex items-center justify-center gap-0.5",
    },
  };

  const getPopUpHeading = () => {
    if (isHardNudge) {
      return {
        head: POP_UP_HEADINGS.HARD_NUDGE_HEAD,
        subhead: POP_UP_HEADINGS.HARD_NUDGE_SUBHEAD,
      };
    } else if (isShareSheet) {
      return {
        head: POP_UP_HEADINGS.SHARE_SHEET_HEAD,
        subhead: POP_UP_HEADINGS.SHARE_SHEET_SUBHEAD,
      };
    } else {
      return {
        head: POP_UP_HEADINGS.DEFAULT_HEAD,
        subhead: POP_UP_HEADINGS.DEFAULT_SUBHEAD,
      };
    }
  };
</script>

<div
  class="install-popup flex flex-col items-center px-4 pb-8 pt-12 font-primary text-center bg-white {isFirstVideo
    ? 'rounded-t-2xl'
    : 'rounded-2xl'}"
>
  {#if !isHardNudge && !isFirstVideo}
    <div class="absolute right-4 top-4 cursor-pointer">
      <img
        src={ImageUrls.CROSS_ICON_BLACK}
        on:click={onClose}
        class="w-4 h-4"
      />
    </div>
  {/if}
  <img src={Logo} class="absolute top-0 -translate-y-2/4 h-20 w-20" alt="Moj" />

  <div class="text-black font-bold text-lg">
    {getPopUpHeading().head}
  </div>

  <div class="text-black font-semibold text-sm mt-2 mb-4">
    {getPopUpHeading().subhead}
  </div>

  <Splide
    class="splide-container w-full mb-3"
    options={{
      start: 0,
      perPage: 1,
      focus: "center",
      ...carouselOptions,
    }}
  >
    {#each VIDEO_FEED_BLOCK.BENEFIT_LIST as benefit}
      <SplideSlide
        class="w-full flex items-center bg-bg-secondary-sc rounded-lg p-3 gap-4"
      >
        <img class="h-8 w-8" src={constants.SUN_EMOJI} alt="sun_emoji" />
        <div class="font-semibold text-sm font-primary">{benefit}</div>
      </SplideSlide>
    {/each}
  </Splide>

  <div class="w-full flex gap-4 justify-center">
    <div on:click={trackDownloadClick} class="flex-1 flex justify-center">
      <InstallButton
        style="font-bold text-base rounded-lg p-3 bg-brand-yellow text-black cursor-pointer flex-1"
        label="Download Now"
        imageSrc={getInstallImage().src}
        imageSrcSet={getInstallImage().srcSet}
        referrer={nudgeType}
        source={nudgeType}
      />
    </div>
  </div>
</div>

<style>
  .install-popup :global(.splide__track) {
    height: 63px;
  }

  .install-popup :global(.splide-pagination-page.is-active) {
    background-color: black;
  }
</style>
